import { AbstractDocument, Untrackable } from '../../../abstract/Document';
import type { ISupplierAdminScore } from './score.types';

@Untrackable
export class AdminScore extends AbstractDocument<ISupplierAdminScore> {
  readonly collections = {};
}
